// ** Initial State
const initialState = {
  dropdown: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedReligion: null
}

const religions = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_RELIGIONS_DROPDOWN':
      return { ...state, dropdown: action.data }
    case 'GET_ALL_RELIGIONS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_RELIGIONS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_RELIGION':
      return { ...state, selectedReligion: action.selectedReligion }
    case 'ADD_RELIGION':
      return { ...state }
    case 'DELETE_RELIGION':
      return { ...state }
    default:
      return { ...state }
  }
}
export default religions
